import { render, staticRenderFns } from "./areaConfig.vue?vue&type=template&id=7f71eb4a&scoped=true"
import script from "./areaConfig.vue?vue&type=script&lang=js"
export * from "./areaConfig.vue?vue&type=script&lang=js"
import style0 from "./areaConfig.vue?vue&type=style&index=0&id=7f71eb4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71eb4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f71eb4a')) {
      api.createRecord('7f71eb4a', component.options)
    } else {
      api.reload('7f71eb4a', component.options)
    }
    module.hot.accept("./areaConfig.vue?vue&type=template&id=7f71eb4a&scoped=true", function () {
      api.rerender('7f71eb4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/areaConfig.vue"
export default component.exports